// @flow

import type { Action } from 'app/common/redux/types';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';

export type State = Viewer;

const initialState = {
  isAuth: false,
  isLimitedLogin: false,
};

const viewer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'BOARD_CREATE_COMPLETE':
      if (state.isAuth) {
        return {
          ...state,
          boardCount: state.boardCount === undefined ? undefined : state.boardCount + 1,
        };
      }
      return state;
    case 'BOARD_DELETE_COMPLETE':
      if (state.isAuth) {
        return {
          ...state,
          boardCount: state.boardCount ? state.boardCount - 1 : state.boardCount,
        };
      }
      return state;
    case 'DISCOVERED_FEED_PUBLIC':
      const { payload } = action;
      if (state.isAuth) {
        return {
          ...state,
          profileDiscoveredPublic: payload.value,
        };
      } else {
        return state;
      }
    case 'RESOURCE_FETCH_COMPLETE':
      // We prefetch profile data in Main.js
      // Update the viewer with board_count and pin_count when we fetch their user data from the resource
      if (
        action.payload.name === 'UserResource' &&
        state.isAuth &&
        action.payload.data &&
        action.payload.data.id === state.id
      ) {
        const { data } = action.payload;

        if (
          data.id !== state.id ||
          (data.board_count === undefined && data.pinCount === undefined)
        ) {
          return state;
        }

        return {
          ...state,
          boardCount: data.board_count === null ? undefined : data.board_count,
          pinCount: data.pinCount === null ? undefined : data.pin_count,
        };
      }

      return state;
    case 'UPDATE_USER_FIRST_HOME_FEED_REQUEST_AFTER_NUX':
      if (state.isAuth) {
        return {
          ...state,
          firstHomeFeedRequestAfterNux: action.payload.firstHomeFeedRequestAfterNux,
        };
      }
      return state;
    case 'UPDATE_USER_PIN_COUNT': {
      const {
        payload: { userId, increment },
      } = action;
      if (state.isAuth && state.id === userId) {
        return {
          ...state,
          pinCount: (state.pinCount || 0) + increment,
        };
      }
      return state;
    }
    case 'UPDATE_USER_SET':
      if (state.isAuth) {
        if (action.payload.partner) {
          action.payload.partner = {
            ...state.partner,
            ...action.payload.partner,
          };
        }

        return {
          ...state,
          ...action.payload,
        };
      }

      return state;
    default:
      return state;
  }
};

export default viewer;
